import React from "react";
import { BsArrowDown } from "react-icons/bs";
import Image from "../../assets/images/about-us-img.png";
const About = () => {
  return (
    <>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 md:px-24 px-12 my-20">
        {/* Description */}
        <div className="my-2 py-5 pr-10 w-full">
          <h1
            style={{}}
            className=" font-light md:text-4xl text-2xl text-black"
          >
            YOUR GO TO <span className="text-pink-600">IT SOLUTIONS </span>
            COMPANY
          </h1>
          <p className="font-light text-black text-md text-left mt-8">
            We are RemotewebNET Dynamics, a leading provider of IT consulting,
            Technical support, and IT Solutions for medium and large-sized
            businesses. It’s a privately owned company founded in the year 2012
            with its headquarters located in Abuja Nigeria. Our experienced
            technicians and engineers work with clients to understand their
            unique technology needs and provide solutions
          </p>
        </div>
        {/* Image */}
        <div className="my-2 py-5 relative w-full md:pl-10 pl-0">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="flex absolute top-1 items-center justify-center bg-pink-600 text-white w-6 h-8">
              <BsArrowDown />
            </div>
          </div>
          <img src={Image} alt="ABout Us" className="w-full h-full" />
        </div>
      </div>
    </>
  );
};

export default About;
